import NotificationsDialog from './notifications-dialog';

export default NotificationsDialog;
